if (!customElements.get('debone-wig-textures')) {
  customElements.define('debone-wig-textures', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form || this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-texture-config]').textContent);
      this.fields = this.querySelector('[data-texture-fields]');
      this.applyAll = this.querySelector('[data-apply-all]');
      this.variantInput = this.form.querySelector('[name="id"]');
      this.config.textures.forEach(texture => this.applyAll.add(new Option(texture, texture)));
      this.onVariantChange = () => this.renderFields();
      this.variantInput.addEventListener('change', this.onVariantChange);
      this.applyAll.addEventListener('change', () => {
        if (!this.applyAll.value) return;
        this.fields.querySelectorAll('select').forEach(select => { select.value = select.dataset.length + ' in — ' + this.applyAll.value; });
      });
      this.fields.addEventListener('change', () => { this.applyAll.value = ''; });
      this.renderFields();
    }
    disconnectedCallback() {
      this.variantInput?.removeEventListener('change', this.onVariantChange);
      this.initialized = false;
    }
    renderFields() {
      const variant = this.config.variants.find(item => item.id === this.variantInput.value);
      if (!variant || variant.id === this.currentVariant) return;
      this.currentVariant = variant.id;
      const previous = Array.from(this.fields.querySelectorAll('select')).map(select => select.value.split(' — ')[1] || '');
      const titleParts = variant.title.split('|');
      const lengthPart = titleParts[1] || '';
      const baseLengths = (lengthPart.split('×')[0].match(/\d+/g) || []);
      const repeat = Number((lengthPart.match(/×\s*(\d+)/) || [])[1] || 1);
      const lengths = baseLengths.flatMap(length => Array(repeat).fill(length));
      const count = Number((titleParts[0].match(/\d+/) || [])[0] || 0);
      this.fields.replaceChildren();
      this.applyAll.value = '';
      this.invalidPackage = count < 1 || lengths.length !== count;
      if (this.invalidPackage) return;
      lengths.forEach((length, index) => {
        const label = document.createElement('label');
        const select = document.createElement('select');
        select.id = this.dataset.formId + '-wig-' + (index + 1);
        select.name = 'properties[Wig ' + (index + 1) + ']';
        select.dataset.length = length;
        select.required = true;
        label.htmlFor = select.id;
        label.textContent = this.config.label.replace('[number]', index + 1).replace('[length]', length);
        select.add(new Option(this.config.placeholder, ''));
        this.config.textures.forEach(texture => select.add(new Option(texture, length + ' in — ' + texture)));
        if (previous[index] && this.config.textures.includes(previous[index])) select.value = length + ' in — ' + previous[index];
        this.fields.append(label, select);
      });
    }
    validate() {
      this.renderFields();
      if (this.invalidPackage) {
        this.closest('product-form')?.handleErrorMessage(this.config.error);
        return false;
      }
      return this.form.reportValidity();
    }
  });
}
